'use client';
import { ApplicationType } from '@unifyapps/defs/types/interface';
import dynamic from 'next/dynamic';
import type { EmitEventType } from '@unifyapps/defs/hooks/useBlockEvents';
import { useInterfaceStore } from '../../stores/InterfaceStore';
import WebInterface from '../WebInterface';
import { PrintProvider } from '../../../context/PrintContext';

const CopilotChatInterface = dynamic(() =>
  import(
    /* webpackChunkName: "CopilotChatInterface" */
    '../CopilotChatInterface'
  ).then((mod) => mod.CopilotChatInterface),
);

const CopilotChatInterfaceWithLauncher = dynamic(() =>
  import(
    /* webpackChunkName: "CopilotChatInterfaceWithLauncher" */
    '../CopilotChatInterface/CopilotChatInterfaceWithLauncher'
  ).then((mod) => mod.CopilotChatInterfaceWithLauncher),
);

export function InterfaceContainer(props: {
  className?: string;
  workspaceClassName?: string;
  colorScheme?: string;
  onClose?: () => void;
  eventEmitterRef?: React.RefObject<{ emitEvent: EmitEventType } | null>;
}) {
  const interfaceRecord = useInterfaceStore().use.record.details();

  if (interfaceRecord.properties.manifest?.type === ApplicationType.COPILOT) {
    return (
      <CopilotChatInterface
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- will be present
        eventEmitterRef={props.eventEmitterRef!}
        onClose={props.onClose}
      />
    );
  }

  return <WebInterface {...props} />;
}

export function MatrixInterfaceContainer(props: {
  className?: string;
  workspaceClassName?: string;
  colorScheme?: string;
}) {
  const interfaceRecord = useInterfaceStore().use.record.details();

  if (interfaceRecord.properties.manifest?.type === ApplicationType.COPILOT) {
    return <CopilotChatInterfaceWithLauncher />;
  }

  return (
    <PrintProvider>
      <WebInterface {...props} />
    </PrintProvider>
  );
}
